export default __webpack_public_path__ + "static/media/JS.a395f138.webp";